import { esES, frFR } from '@mui/x-date-pickers/locales';
import { isValid, parseISO } from 'date-fns';
import { ar, enGB, es, fr } from 'date-fns/locale';

/** Dates travel in the URL as the API takes them. */
export const VALUE_FORMAT = 'yyyy-MM-dd';

const DATE_LOCALES = { en: enGB, fr, es, ar };

/** The picker's own words (Clear, Today, the arrows' labels); English is its default. */
const PICKER_TEXT = {
  fr: frFR.components.MuiLocalizationProvider.defaultProps.localeText,
  es: esES.components.MuiLocalizationProvider.defaultProps.localeText,
};

type Language = keyof typeof DATE_LOCALES;

/** The date-fns locale and picker text for the app's language, shared by the date pickers. */
export const pickerLocale = (appLanguage: string | undefined) => {
  const language = (appLanguage?.split('-')[0] ?? 'en') as Language;
  return {
    locale: DATE_LOCALES[language] ?? enGB,
    localeText: PICKER_TEXT[language as keyof typeof PICKER_TEXT],
  };
};

/** A `yyyy-MM-dd` value as a date, or null for none or a bad one. */
export const toDate = (value: string | undefined): Date | null => {
  if (!value) return null;
  const date = parseISO(value);
  return isValid(date) ? date : null;
};
